export const COURSE_STATUS = {
  DRAFT: 1,
  PLANNED: 2,
  READY: 3,
  ARCHIVED: 4,
  ONGOING: 5,
} as const;

export type CourseStatus = (typeof COURSE_STATUS)[keyof typeof COURSE_STATUS];
export const COURSE_STATUS_NAMES = {
  [COURSE_STATUS.DRAFT]: "Wersja robocza",
  [COURSE_STATUS.PLANNED]: "Zaplanowany",
  [COURSE_STATUS.READY]: "Gotowy",
  [COURSE_STATUS.ARCHIVED]: "Zarchiwizowany",
  [COURSE_STATUS.ONGOING]: "Trwający",
};

export const COURSE_STATUS_COLORS: Record<CourseStatus, string> = {
  [COURSE_STATUS.DRAFT]: "amber",
  [COURSE_STATUS.PLANNED]: "indigo",
  [COURSE_STATUS.READY]: "emerald",
  [COURSE_STATUS.ARCHIVED]: "slate",
  [COURSE_STATUS.ONGOING]: "primary",
} as const;

export const COURSE_STATUS_CLASS: Record<CourseStatus, string> = {
  [COURSE_STATUS.DRAFT]: "text-amber-500",
  [COURSE_STATUS.PLANNED]: "text-indigo-500",
  [COURSE_STATUS.READY]: "text-emerald-500",
  [COURSE_STATUS.ARCHIVED]: "text-slate-500",
  [COURSE_STATUS.ONGOING]: "text-primary-500",
} as const;

const COURSE_STATUS_DRAFT = {
  label: COURSE_STATUS_NAMES[COURSE_STATUS.DRAFT],
  value: COURSE_STATUS.DRAFT,
  color: COURSE_STATUS_COLORS[COURSE_STATUS.DRAFT],
};
const COURSE_STATUS_PLANNED = {
  label: COURSE_STATUS_NAMES[COURSE_STATUS.PLANNED],
  value: COURSE_STATUS.PLANNED,
  color: COURSE_STATUS_COLORS[COURSE_STATUS.PLANNED],
};
const COURSE_STATUS_ARCHIVED = {
  label: COURSE_STATUS_NAMES[COURSE_STATUS.ARCHIVED],
  value: COURSE_STATUS.ARCHIVED,
  color: COURSE_STATUS_COLORS[COURSE_STATUS.ARCHIVED],
};
const COURSE_STATUS_ONGOING = {
  label: COURSE_STATUS_NAMES[COURSE_STATUS.ONGOING],
  value: COURSE_STATUS.ONGOING,
  color: COURSE_STATUS_COLORS[COURSE_STATUS.ONGOING],
};
const COURSE_STATUS_READY = {
  label: COURSE_STATUS_NAMES[COURSE_STATUS.READY],
  value: COURSE_STATUS.READY,
  color: COURSE_STATUS_COLORS[COURSE_STATUS.READY],
};

export const COURSE_STATUS_OPTIONS = [
  COURSE_STATUS_DRAFT,
  COURSE_STATUS_PLANNED,
  COURSE_STATUS_READY,
  COURSE_STATUS_ONGOING,
  COURSE_STATUS_ARCHIVED,
];
